import { useMemo } from 'react'
import { preFixImgUrl } from '@/utils'

export type BenefitCard = {
  img: string
  titleKey: string
  descKey: string
}

export type HowToScreen = {
  img: string
  titleKey: string
}

export type QuickLinkItem = {
  key: string
  iconImg: string
}

const BENEFIT_ILL_FILES = [
  '8359b5b1bf41eb26542bd1b836a276b7.png',
  'bc8c1eb9dc6e70318703b81a6fce1b28.png',
  'e2b347132a8379a14e5f420be5847190.png',
  '5a8d24e24037aa2df2f563d604569773.png',
] as const

const BENEFIT_TITLE_KEYS = ['318650ee', 'be004f13', 'c33ce7f5', '4b9ebb9c'] as const
const BENEFIT_DESC_KEYS = ['49b76537', '2ff42cdc', 'd2e27565', 'dca1ec53'] as const

/** 使用步骤手机截图（与线上一致，可替换） */
const HOWTO_IMG_FILES = [
  '210699842e12567f03122f89be15dd78.png',
  '2bb191c8db68703df4acfc464a9f198a.png',
  'ae8ff2ac7402ec20fbba892c6e94a2d9.png',
  '713c76ae98307c3875b3fef3391a7cab.png',
] as const

const HOWTO_TITLE_KEYS = ['498f0c35', '5f0b58af', '69fd2eb1', '9eac6ba3'] as const

const QUICK_LINK_KEYS = ['00a5d8ee', '487853f3', '2aefc7a2', '2c7782ea'] as const
const QUICK_LINK_ICON_FILES = [
  'e62cca86d301cb431507da5775a49803.png',
  '604ce17e39d715e03b02aba7b3874804.png',
  '05e814b0f7beb684207c85db7417ec8d.png',
  '691e96c40a4369e0f941c4b9fdf709da.png',
] as const

export default function useModel() {
  const benefitCards = useMemo<BenefitCard[]>(
    () =>
      BENEFIT_ILL_FILES.map((file, i) => ({
        img: preFixImgUrl(file),
        titleKey: BENEFIT_TITLE_KEYS[i],
        descKey: BENEFIT_DESC_KEYS[i],
      })),
    [],
  )

  const howToScreens = useMemo<HowToScreen[]>(
    () =>
      HOWTO_IMG_FILES.map((file, i) => ({
        img: preFixImgUrl(file),
        titleKey: HOWTO_TITLE_KEYS[i],
      })),
    [],
  )

  const quickLinks = useMemo<QuickLinkItem[]>(
    () =>
      QUICK_LINK_KEYS.map((key, i) => ({
        key,
        iconImg: preFixImgUrl(QUICK_LINK_ICON_FILES[i]),
      })),
    [],
  )

  return { benefitCards, howToScreens, quickLinks }
}
